import './App.scss';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Layout from './Layout/Components/Layout';
import ActivitiesPage from './Activities/Components/ActivitiesPage';
import ErrorPage from './ErrorPage';
import { abpnClient } from './Services/AbpnClient';
import { appInsights } from './Services/AppInsights';

function App() {
  const baseName = '/activities';
  appInsights.load();
  abpnClient.setErrorPage(`${baseName}/error`);

  return (
    <BrowserRouter basename={baseName}>
      <Layout>
        <Routes>
          <Route path="/error" element={<ErrorPage />} />
          <Route path="/" element={<ActivitiesPage />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
